var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDualperson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4136_3550",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4136_3550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 33.3334V28.6667C1.6665 27.7223 1.90956 26.8542 2.39567 26.0626C2.88178 25.2709 3.52762 24.6667 4.33317 24.2501C6.05539 23.389 7.80539 22.7431 9.58317 22.3126C11.3609 21.882 13.1665 21.6667 14.9998 21.6667C16.8332 21.6667 18.6387 21.882 20.4165 22.3126C22.1943 22.7431 23.9443 23.389 25.6665 24.2501C26.4721 24.6667 27.1179 25.2709 27.604 26.0626C28.0901 26.8542 28.3332 27.7223 28.3332 28.6667V33.3334H1.6665ZM31.6665 33.3334V28.3334C31.6665 27.1112 31.3262 25.9376 30.6457 24.8126C29.9651 23.6876 28.9998 22.7223 27.7498 21.9167C29.1665 22.0834 30.4998 22.3681 31.7498 22.7709C32.9998 23.1737 34.1665 23.6667 35.2498 24.2501C36.2498 24.8056 37.0137 25.4237 37.5415 26.1042C38.0693 26.7848 38.3332 27.5279 38.3332 28.3334V33.3334H31.6665ZM14.9998 20.0001C13.1665 20.0001 11.5971 19.3473 10.2915 18.0417C8.98595 16.7362 8.33317 15.1667 8.33317 13.3334C8.33317 11.5001 8.98595 9.93064 10.2915 8.62508C11.5971 7.31953 13.1665 6.66675 14.9998 6.66675C16.8332 6.66675 18.4026 7.31953 19.7082 8.62508C21.0137 9.93064 21.6665 11.5001 21.6665 13.3334C21.6665 15.1667 21.0137 16.7362 19.7082 18.0417C18.4026 19.3473 16.8332 20.0001 14.9998 20.0001ZM31.6665 13.3334C31.6665 15.1667 31.0137 16.7362 29.7082 18.0417C28.4026 19.3473 26.8332 20.0001 24.9998 20.0001C24.6943 20.0001 24.3054 19.9654 23.8332 19.8959C23.361 19.8265 22.9721 19.7501 22.6665 19.6667C23.4165 18.7779 23.9929 17.7917 24.3957 16.7084C24.7985 15.6251 24.9998 14.5001 24.9998 13.3334C24.9998 12.1667 24.7985 11.0417 24.3957 9.95841C23.9929 8.87508 23.4165 7.88897 22.6665 7.00008C23.0554 6.86119 23.4443 6.77091 23.8332 6.72925C24.2221 6.68758 24.6109 6.66675 24.9998 6.66675C26.8332 6.66675 28.4026 7.31953 29.7082 8.62508C31.0137 9.93064 31.6665 11.5001 31.6665 13.3334Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDualperson);
export default __webpack_public_path__ + "static/media/dualperson.d21fd998927528c4d0add5e235f61f31.svg";
export { ForwardRef as ReactComponent };